import React, { useState } from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { combinedKeyPressHandler } from '@/helpers/utils/siteUtils';

interface InputFieldProps {
  items?: string;
  id?: string;
  classname?: string;
  htmlFor?: string;
  value?: string;
  disabled?: boolean;
  onChange?: any;
}

const FloatingTextArea: React.FC<InputFieldProps> = ({ items, id, htmlFor, value, disabled, onChange }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const [characterCount, setCharacterCount] = useState(inputValue.length);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    setCharacterCount(newValue.length);
    if (onChange) onChange(event);
  };

  return (
    <section className="relative w-full">
      <section className="relative">
        <textarea
          id={id}
          className="peer block min-h-[80px] w-full appearance-none rounded-lg border-2 border-gray-300 bg-transparent px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-0"
          placeholder=" "
          value={inputValue}
          name={htmlFor}
          disabled={disabled}
          onChange={handleInputChange}
          maxLength={60}
          onKeyPress={combinedKeyPressHandler}
        />

        <label
          htmlFor={htmlFor}
          className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-gray-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
        >
          {items}
        </label>
      </section>
      <p className=" mt-4 flex justify-end text-xs">
        {characterCount}
        {mapLocaleToMeaningfulFormat().giftMessageLength}
      </p>
    </section>
  );
};

export default FloatingTextArea;
